export {
  selectThisSlice,
  selectCustomer,
  selectAnalysisPageCustomer,
  selectCustomerSettingsSource,
  selectIsLoading,
  selectIsLoaded,

  selectHasActionPlans,
  selectHasClosureReports,

  selectHasTabLinesCardView,
  selectHasTabLinesTableView,
  selectHasTabMyProjects,

  selectHasTabReports,
  selectHasTabCustomReportsV1,
  selectHasTabCustomReportsV2,
  selectHasTabReportPercentPassing,
  selectHasTabReportTotalMiles,

  selectHasCustomerCreatedJobs,
  selectHasDefaultUploadsToSearchable,

  selectHasSharedState,
  selectHasBehaviorAutoRemoveIliData,
  selectHasFeatureEnablePsqlIliData,
  selectHasFeatureEnableTempUploadAutoRemove,
  selectHasFeatureEnablePersistLinkedSurveys,
  selectHasFeatureClosureCopyActionPlan,
} from './selectors.core';

export {
  selectHasActionPlansForAnalysisPage,
  selectHasClosureReportsForAnalysisPage,
  selectHasSharedStateForAnalysisPage,
  selectHasBehaviorAutoRemoveIliDataForAnalysisPage,
  selectHasSettingEnableTempUploadAutoRemoveForAnalysisPage,
  selectHasSettingEnableCustomerCreatedJobsForAnalysisPage,
  selectHasSettingHasDefaultUploadsToSearchableForAnalysisPage,
  selectHasSettingEnablePersistLinkedSurveysForAnalysisPage,
  selectHasFeatureClosureCopyActionPlanForAnalysisPage,
} from './selectors.analysis.page';